import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';

import { CommonModule } from '@angular/common';
import { ListRolesComponent } from './list-roles/list-roles.component';
@Component({
    selector: 'app-role-management',
    templateUrl: './role-management.component.html',
    styleUrl: './role-management.component.css',
    imports: [CommonModule, RouterModule, ListRolesComponent]
})
export class RoleManagementComponent {
  showMainContent: boolean = true;

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateContentVisibility();
    });
  }

  ngOnInit() {
    this.updateContentVisibility();
  }

  private updateContentVisibility() {
    const path = this.router.url;
    const childRoutes = ['/role-management/create-role', '/role-management/view-role', '/role-management/update-role'];
    this.showMainContent = !childRoutes.some(route => path.startsWith(route));
  }
}
